module.exports = __webpack_public_path__ + "img/serviceImg4.d13c464c.png";